import { useEffect, useState } from "react";
import { Box, Card, CardContent, Typography } from "../../../../components";
import { Divider } from "@mui/material";
import { DashboardChart } from "../../../main/components";
import { OrdemServicoService } from "../../../../services";
import { responseErros } from "../../../../utils";

const ordemServicoService = new OrdemServicoService();

function formatarNome(nome) {
  if (!nome) return nome;
  return nome
    .toLowerCase()
    .split(" ")
    .map((parte) =>
      parte ? parte.charAt(0).toUpperCase() + parte.slice(1) : parte,
    )
    .join(" ");
}

function MonitorOsFluxo({ filtrosBody }) {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({ categories: [], series: [] });

  useEffect(() => {
    buscarFluxo();
  }, [filtrosBody]);

  async function buscarFluxo() {
    setLoading(true);
    const result = await ordemServicoService.getRelatorioDashboardFluxo(
      filtrosBody,
    );
    if (!result.isAxiosError) {
      const rows = result.data || [];
      setData({
        categories: rows.map((r) => formatarNome(r.name)),
        series: [
          {
            name: "O.S",
            type: "pie",
            data: rows.map((r) => ({
              name: formatarNome(r.name),
              y: r.y,
              color: r?.color,
            })),
          },
        ],
      });
    } else {
      responseErros(result);
    }
    setLoading(false);
  }

  return (
    <Card sx={{ borderRadius: 3, border: "1px solid #f0f0f0", height: "100%" }}>
      <CardContent sx={{ p: 2, display: "flex", flexDirection: "column", height: "100%" }}>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          mb={1}
          flexShrink={0}
        >
          <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
            Fluxo das Ordens de Serviço
          </Typography>
          <i
            className="ph-bold ph-chart-pie"
            style={{ color: "#64748b", fontSize: 20 }}
          />
        </Box>
        <Divider sx={{ mb: 2, flexShrink: 0 }} />
        <Box
          sx={{
            flex: 1,
            minHeight: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            maxHeight: 380, // Limite de altura do container
            overflow: "hidden"
          }}
        >
          <DashboardChart
            loading={loading}
            data={data}
            heightChart={350} // Forçando altura fixa no componente do gráfico
            options={{
              chart: { 
                type: "pie",
                height: 350, // Forçando altura no Highcharts
                spacing: [10, 10, 10, 10]
              },
              plotOptions: {
                pie: {
                  size: '80%', // Limitando o tamanho da pizza em relação ao container
                  allowPointSelect: true,
                  cursor: "pointer",
                  dataLabels: {
                    enabled: true,
                    format: "<b>{point.name}</b>: {point.y}",
                    style: {
                      color: "#1e293b",
                      textOutline: "none",
                      fontSize: '11px',
                      fontWeight: 600,
                    },
                    distance: 15 // Distância dos labels para não fugir da tela
                  },
                  showInLegend: true,
                },
              },
              legend: {
                enabled: true,
                itemStyle: { color: "#1e293b", fontSize: '11px' },
                padding: 0,
                margin: 5
              },
              tooltip: {
                pointFormat:
                  "<b>{point.name}</b>: {point.y} O.S ({point.percentage:.1f}%)",
              },
            }}
          />
        </Box>
      </CardContent>
    </Card>
  );
}

export default MonitorOsFluxo;
